import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
import LoaderIcon from '../Loader';
export var Loader = styled(LoaderIcon).withConfig({
  displayName: "ui-kit-Loader",
  componentId: "ui-kit-16fcy2g"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  margin: auto;\n  width: 20px;\n  height: 20px;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  margin: auto;\n  width: 20px;\n  height: 20px;\n"])));
export var IconWrap = styled.span.withConfig({
  displayName: "ui-kit-IconWrap",
  componentId: "ui-kit-1ama2o5"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
export var LeftIconWrap = styled(IconWrap).withConfig({
  displayName: "ui-kit-LeftIconWrap",
  componentId: "ui-kit-qwk2lb"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: -2px;\n  margin-right: 8px;\n"], ["\n  margin-left: -2px;\n  margin-right: 8px;\n"])));
export var RightIconWrap = styled(LeftIconWrap).withConfig({
  displayName: "ui-kit-RightIconWrap",
  componentId: "ui-kit-14rhv1h"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: 8px;\n  margin-right: -2px;\n"], ["\n  margin-left: 8px;\n  margin-right: -2px;\n"])));

var primaryColorMixin = function primaryColorMixin(fill) {
  return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: ", ";\n\n  &:hover:not(.disabled):not(.loading) {\n    background: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    background: ", ";\n    box-shadow: none;\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n"], ["\n  background: ", ";\n\n  &:hover:not(.disabled):not(.loading) {\n    background: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    background: ", ";\n    box-shadow: none;\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].mid;
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].high;
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].highest;
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].overlay24;
  });
};

var secondaryColorMixin = function secondaryColorMixin(fill, label) {
  return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background: ", ";\n\n  & > ", " {\n    color: ", ";\n  }\n\n  &:not(.disabled):not(.loading) {\n    color: ", ";\n  }\n\n  &:hover:not(.disabled):not(.loading) {\n    color: ", ";\n    background: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    color: ", ";\n    background: ", ";\n    box-shadow: none;\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    padding: 9px 21px;\n    border: 3px solid ", ";\n\n    &.withIcon {\n      padding: 9px;\n    }\n\n    &.sizeLarge {\n      padding: 13px 29px;\n\n      &.withIcon {\n        padding: 13px;\n      }\n    }\n\n    &.sizeSmall {\n      padding: 5px 13px;\n\n      &.withIcon {\n        padding: 5px;\n      }\n    }\n  }\n"], ["\n  background: ", ";\n\n  & > "
  /* sc-sel */
  , " {\n    color: ", ";\n  }\n\n  &:not(.disabled):not(.loading) {\n    color: ", ";\n  }\n\n  &:hover:not(.disabled):not(.loading) {\n    color: ", ";\n    background: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    color: ", ";\n    background: ", ";\n    box-shadow: none;\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    padding: 9px 21px;\n    border: 3px solid ", ";\n\n    &.withIcon {\n      padding: 9px;\n    }\n\n    &.sizeLarge {\n      padding: 13px 29px;\n\n      &.withIcon {\n        padding: 13px;\n      }\n    }\n\n    &.sizeSmall {\n      padding: 5px 13px;\n\n      &.withIcon {\n        padding: 5px;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].overlay16;
  },
  /* sc-sel */
  Loader, function (_a) {
    var theme = _a.theme;
    return theme.palette.label[label];
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.label[label];
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.label[label === 'accent' ? "".concat(label, "High") : label];
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].overlay24;
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.label[label === 'accent' ? "".concat(label, "Highest") : label];
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].overlay32;
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].overlay24;
  });
};

var outlineColorMixin = function outlineColorMixin(fill, label) {
  return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  border: 1px solid ", ";\n\n  & > ", " {\n    color: ", ";\n  }\n\n  &:not(.disabled):not(.loading) {\n    color: ", ";\n  }\n\n  &:hover:not(.disabled):not(.loading) {\n    background: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    background: ", ";\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n"], ["\n  border: 1px solid ", ";\n\n  & > "
  /* sc-sel */
  , " {\n    color: ", ";\n  }\n\n  &:not(.disabled):not(.loading) {\n    color: ", ";\n  }\n\n  &:hover:not(.disabled):not(.loading) {\n    background: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    background: ", ";\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].low;
  },
  /* sc-sel */
  Loader, function (_a) {
    var theme = _a.theme;
    return theme.palette.label[label];
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.label[label];
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].overlay16;
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].overlay24;
  }, function (_a) {
    var theme = _a.theme;
    return theme.palette.fill[fill].overlay24;
  });
};

var loadingMixin = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  &.loading {\n    color: rgba(0, 0, 0, 0);\n    cursor: default;\n    box-shadow: none;\n  }\n\n  & svg:not(", ") {\n    color: inherit;\n  }\n\n  &.disabled > ", " {\n    color: ", ";\n  }\n"], ["\n  &.loading {\n    color: rgba(0, 0, 0, 0);\n    cursor: default;\n    box-shadow: none;\n  }\n\n  & svg:not("
/* sc-sel */
, ") {\n    color: inherit;\n  }\n\n  &.disabled > "
/* sc-sel */
, " {\n    color: ", ";\n  }\n"])),
/* sc-sel */
Loader,
/* sc-sel */
Loader, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
});
export var BaseButton = styled.button.withConfig({
  displayName: "ui-kit-BaseButton",
  componentId: "ui-kit-ekw2d7"
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  height: 48px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n  font-family: ", ";\n  text-align: center;\n  line-height: 24px;\n  letter-spacing: -0.008em;\n  border-radius: 8px;\n  cursor: pointer;\n  outline: none;\n  border: none;\n  text-decoration: none;\n  position: relative;\n  min-width: 77px;\n  box-sizing: border-box;\n\n  &.withIcon {\n    padding: 12px;\n    min-width: 48px;\n  }\n\n  &.sizeLarge {\n    height: 56px;\n    font-size: 17px;\n    letter-spacing: -0.012em;\n    font-weight: 600;\n    padding: 16px 32px;\n\n    &.withIcon {\n      padding: 16px;\n      min-width: 56px;\n    }\n  }\n\n  &.sizeSmall {\n    height: 40px;\n    font-size: 14px;\n    letter-spacing: -0.004em;\n    font-style: normal;\n    padding: 8px 16px;\n\n    &.withIcon {\n      padding: 8px;\n      min-width: 40px;\n    }\n  }\n\n  &.disabled {\n    color: ", ";\n    box-shadow: none;\n    cursor: default;\n  }\n\n  &.fullWidth {\n    width: 100%;\n  }\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  height: 48px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n  font-family: ", ";\n  text-align: center;\n  line-height: 24px;\n  letter-spacing: -0.008em;\n  border-radius: 8px;\n  cursor: pointer;\n  outline: none;\n  border: none;\n  text-decoration: none;\n  position: relative;\n  min-width: 77px;\n  box-sizing: border-box;\n\n  &.withIcon {\n    padding: 12px;\n    min-width: 48px;\n  }\n\n  &.sizeLarge {\n    height: 56px;\n    font-size: 17px;\n    letter-spacing: -0.012em;\n    font-weight: 600;\n    padding: 16px 32px;\n\n    &.withIcon {\n      padding: 16px;\n      min-width: 56px;\n    }\n  }\n\n  &.sizeSmall {\n    height: 40px;\n    font-size: 14px;\n    letter-spacing: -0.004em;\n    font-style: normal;\n    padding: 8px 16px;\n\n    &.withIcon {\n      padding: 8px;\n      min-width: 40px;\n    }\n  }\n\n  &.disabled {\n    color: ", ";\n    box-shadow: none;\n    cursor: default;\n  }\n\n  &.fullWidth {\n    width: 100%;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
});
export var PrimaryButton = styled(BaseButton).withConfig({
  displayName: "ui-kit-PrimaryButton",
  componentId: "ui-kit-1j75dgi"
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  box-shadow: ", ";\n  color: ", ";\n\n  & > ", " {\n    color: ", ";\n  }\n\n  ", "\n\n  &.colorPositive {\n    ", "\n  }\n\n  &.colorNegative {\n    ", "\n  }\n\n  &.disabled {\n    background: ", ";\n  }\n\n  ", "\n"], ["\n  box-shadow: ", ";\n  color: ", ";\n\n  & > "
/* sc-sel */
, " {\n    color: ", ";\n  }\n\n  ", "\n\n  &.colorPositive {\n    ", "\n  }\n\n  &.colorNegative {\n    ", "\n  }\n\n  &.disabled {\n    background: ", ";\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.shadow.button;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.static.white;
},
/* sc-sel */
Loader, function (_a) {
  var theme = _a.theme;
  return theme.palette.static.white;
}, primaryColorMixin('primary'), primaryColorMixin('positive'), primaryColorMixin('negative'), function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.overlay16;
}, loadingMixin);
export var SecondaryButton = styled(BaseButton).withConfig({
  displayName: "ui-kit-SecondaryButton",
  componentId: "ui-kit-1pfccd5"
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n\n  &.colorPositive {\n    ", "\n  }\n\n  &.colorNegative {\n    ", "\n  }\n\n  &.disabled {\n    background: ", ";\n  }\n\n  ", "\n"], ["\n  ", "\n\n  &.colorPositive {\n    ", "\n  }\n\n  &.colorNegative {\n    ", "\n  }\n\n  &.disabled {\n    background: ", ";\n  }\n\n  ", "\n"])), secondaryColorMixin('primary', 'accent'), secondaryColorMixin('positive', 'positive'), secondaryColorMixin('negative', 'negative'), function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.overlay16;
}, loadingMixin);
export var GhostButton = styled(BaseButton).withConfig({
  displayName: "ui-kit-GhostButton",
  componentId: "ui-kit-3fbdyk"
})(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  background: transparent;\n  color: ", ";\n\n  & > ", " {\n    color: ", ";\n  }\n\n  &:hover:not(.disabled):not(.loading) {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  &.disabled {\n    background: transparent;\n  }\n\n  ", "\n"], ["\n  background: transparent;\n  color: ", ";\n\n  & > "
/* sc-sel */
, " {\n    color: ", ";\n  }\n\n  &:hover:not(.disabled):not(.loading) {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  &.disabled {\n    background: transparent;\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.secondary;
},
/* sc-sel */
Loader, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.overlay16;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.secondaryHigh;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.overlay32;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay24;
}, loadingMixin);
export var TextButton = styled(BaseButton).withConfig({
  displayName: "ui-kit-TextButton",
  componentId: "ui-kit-15iqkvk"
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  color: ", ";\n  background: none;\n\n  & > ", " {\n    color: ", ";\n  }\n\n  &:hover:not(.disabled):not(.loading) {\n    color: ", ";\n    background: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    color: ", ";\n    background: ", ";\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  background: none;\n\n  & > "
/* sc-sel */
, " {\n    color: ", ";\n  }\n\n  &:hover:not(.disabled):not(.loading) {\n    color: ", ";\n    background: ", ";\n  }\n\n  &:active:not(.disabled):not(.loading) {\n    color: ", ";\n    background: ", ";\n  }\n\n  &:focus-visible:not(.disabled):not(.loading) {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.accent;
},
/* sc-sel */
Loader, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.accent;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.accentHigh;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay16;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.accentHighest;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay24;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay24;
}, loadingMixin);
export var OutlineButton = styled(BaseButton).withConfig({
  displayName: "ui-kit-OutlineButton",
  componentId: "ui-kit-iiyamz"
})(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  padding: 11px 23px;\n  background: none;\n\n  ", "\n\n  &.withIcon {\n    padding: 11px;\n  }\n\n  &.sizeLarge {\n    padding: 15px 31px;\n\n    &.withIcon {\n      padding: 15px;\n    }\n  }\n\n  &.sizeSmall {\n    padding: 7px 15px;\n\n    &.withIcon {\n      padding: 7px;\n    }\n  }\n\n  &.colorPositive {\n    ", "\n  }\n\n  &.colorNegative {\n    ", "\n  }\n\n  &.disabled {\n    border-color: ", ";\n  }\n\n  ", "\n"], ["\n  padding: 11px 23px;\n  background: none;\n\n  ", "\n\n  &.withIcon {\n    padding: 11px;\n  }\n\n  &.sizeLarge {\n    padding: 15px 31px;\n\n    &.withIcon {\n      padding: 15px;\n    }\n  }\n\n  &.sizeSmall {\n    padding: 7px 15px;\n\n    &.withIcon {\n      padding: 7px;\n    }\n  }\n\n  &.colorPositive {\n    ", "\n  }\n\n  &.colorNegative {\n    ", "\n  }\n\n  &.disabled {\n    border-color: ", ";\n  }\n\n  ", "\n"])), outlineColorMixin('primary', 'accent'), outlineColorMixin('positive', 'positive'), outlineColorMixin('negative', 'negative'), function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.muted;
}, loadingMixin);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;